<div class="userRecordsLink">
  <a class="bciti-inline-button" routerLink="/user-records" routerLinkActive="active">
    <span class="icon-arrow-left"></span>
    <span>{{ 'pages.user-update.returnToUserSearch' | translate }}</span>
  </a>
</div>
<hr/>
<header class="page-header">
  <h3 class="page-heading">{{ 'pages.user-update.headerTitle' | translate }} - <span class="sub-heading">{{name$ | async}}</span></h3>
</header>
<ng-container *ngIf="(userRecord$ | async)">
  <app-bciti-tabs [badges]="[]">
    <ng-container *ngFor="let adminTab of adminTabs">
      <app-bciti-tab [title]="adminTab.titleKey | translate" [pluginId]="adminTab.pluginId" *ngIf="adminTab?.visible">
        <app-user-profile
          *ngIf="adminTab.name == 'Profile'"
        ></app-user-profile>
        <app-user-card
          *ngIf="adminTab.name == 'Cards'"
        ></app-user-card>
        <app-user-family
        *ngIf="adminTab.name == 'Family'"
        ></app-user-family>
        <app-user-subscriptions
          *ngIf="adminTab.name == 'Subscriptions'"
        ></app-user-subscriptions>
        <app-user-receipts
          *ngIf="adminTab.name == 'Receipts'"
        ></app-user-receipts>
        <app-user-requests
          *ngIf="adminTab.name == 'Requests'"
        ></app-user-requests>
        <app-user-history
          *ngIf="adminTab.name == 'History'"
        ></app-user-history>
        <app-user-vehicle
          *ngIf="adminTab.name == 'Vehicle'"
        ></app-user-vehicle>
        <app-user-parking
          *ngIf="adminTab.name == 'Parking'"
        ></app-user-parking>
        <app-user-parking
          *ngIf="adminTab.name == 'Permit'"
        ></app-user-parking>
        <app-iframe-page
          *ngIf="adminTab.name != 'Profile' && adminTab.name != 'Cards' && adminTab.name != 'Requests' && adminTab.name != 'Receipts' && adminTab.name != 'Subscriptions' && adminTab.name != 'Family' && adminTab.name != 'History' && adminTab.name != 'Vehicle' && adminTab.name != 'Parking' && adminTab.name != 'Permit' && !loading && adminTab?.isIframe"
          [moduleId]="adminTab.pluginId"
        ></app-iframe-page>
      </app-bciti-tab>
    </ng-container>
  </app-bciti-tabs>
</ng-container>
